import { META_CONSTANTS } from '../actionTypes'

const initState = {
	translation: {
		status: 0,
		translate: [],
	},
	toaster: {
		status: 0,
		addToast: [],
	},
}

const metaDataReducer = (state = initState, action) => {
	switch (action.type) {
		case 'RESET':
			return initState
		case META_CONSTANTS.SAVE_TOAST:
			return {
				...state,
				toaster: {
					status: 1,
					addToast: action.response,
				},
			}
		case META_CONSTANTS.SAVE_TRANSLATION:
			return {
				...state,
				translation: {
					status: 1,
					translate: action.response,
				},
			}
		default:
			return state
	}
}
export default metaDataReducer
